import React from 'react'

export function TasksIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M10 3H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2h-4'
        stroke='currentColor'
        strokeWidth='2'
      />
      <path d='M8 13l3 3 5-5' stroke='currentColor' strokeWidth='2' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 3c0 .35-.06.687-.17 1H16v2H8V4h1.17A3 3 0 1115 3zm-3 1a1 1 0 100-2 1 1 0 000 2z'
        fill='currentColor'
      />
    </svg>
  )
}
